// Bizting 개인정보처리방침 V11이 예정 버전에서 현재 버전으로 전환되는 시행 시점입니다.
export const PRIVACY_V11_EFFECTIVE_AT = new Date("2026-05-01T00:00:00+09:00");

// Bizting 이용약관 V11이 예정 버전에서 현재 버전으로 전환되는 시행 시점입니다.
export const TERMS_V11_EFFECTIVE_AT = new Date("2026-05-01T00:00:00+09:00");

// Bizting 개인정보처리방침 V12를 예정 버전으로 고지하기 시작하는 시점입니다.
export const PRIVACY_V12_NOTICE_START_AT = new Date("2026-05-04T00:00:00+09:00");

// Bizting 개인정보처리방침 V12가 예정 버전에서 현재 버전으로 전환되는 시행 시점입니다.
export const PRIVACY_V12_EFFECTIVE_AT = new Date("2026-06-05T00:00:00+09:00");

// NPass 개인정보처리방침 1.1을 예정 버전으로 고지하기 시작하는 시점입니다.
export const NPASS_V11_NOTICE_START_AT = new Date("2026-05-04T00:00:00+09:00");

// NPass 개인정보처리방침 1.1이 예정 버전에서 현재 버전으로 전환되는 시행 시점입니다.
export const NPASS_V11_EFFECTIVE_AT = new Date("2026-06-05T00:00:00+09:00");

// NPass 개인정보처리방침 1.2를 예정 버전으로 고지하기 시작하는 시점입니다.
export const NPASS_V12_NOTICE_START_AT = new Date("2026-08-25T00:00:00+09:00");

// NPass 개인정보처리방침 1.2가 예정 버전에서 현재 버전으로 전환되는 시행 시점입니다. (추석 연휴를 피해 28일로 조정)
export const NPASS_V12_EFFECTIVE_AT = new Date("2026-09-28T00:00:00+09:00");

// Bizting 개인정보처리방침 V13을 예정 버전으로 고지하기 시작하는 시점입니다.
export const PRIVACY_V13_NOTICE_START_AT = new Date("2026-08-25T00:00:00+09:00");

// Bizting 개인정보처리방침 V13이 예정 버전에서 현재 버전으로 전환되는 시행 시점입니다.
export const PRIVACY_V13_EFFECTIVE_AT = new Date("2026-09-28T00:00:00+09:00");

// Bizting 개인정보처리방침 V14를 예정 버전으로 고지하기 시작하는 시점입니다.
export const PRIVACY_V14_NOTICE_START_AT = new Date("2026-09-28T00:00:00+09:00");

// Bizting 개인정보처리방침 V14가 예정 버전에서 현재 버전으로 전환되는 시행 시점입니다.
export const PRIVACY_V14_EFFECTIVE_AT = new Date("2026-10-28T00:00:00+09:00");

// Bizting 이용약관 V12를 예정 버전으로 고지하기 시작하는 시점입니다.
export const TERMS_V12_NOTICE_START_AT = new Date("2026-09-28T00:00:00+09:00");

// Bizting 이용약관 V12가 예정 버전에서 현재 버전으로 전환되는 시행 시점입니다.
export const TERMS_V12_EFFECTIVE_AT = new Date("2026-10-28T00:00:00+09:00");

// ────────────────────────────────────────────────────────
// 버전 네비게이션 헬퍼
// "현재 버전"/"예정 버전" 버튼은 특정 버전 번호에 고정하지 않고,
// 지금 시각 기준으로 실제 시행중인/고지중인 버전을 계산해서 그 경로로 이동시킨다.
// 새 버전이 나올 때마다 이 함수들만 갱신하면, 각 문서 파일의 버튼은 손댈 필요가 없다.
// ────────────────────────────────────────────────────────

/** 지금 시각 기준으로 실제 시행중인 비즈팅 개인정보처리방침 버전의 경로를 반환한다. */
export function getCurrentBiztingPrivacyRoute(now: Date = new Date()): string {
  if (now >= PRIVACY_V14_EFFECTIVE_AT) return "/clause/privacy/v1.4";
  if (now >= PRIVACY_V13_EFFECTIVE_AT) return "/clause/privacy/v1.3";
  if (now >= PRIVACY_V12_EFFECTIVE_AT) return "/clause/privacy/v1.2";
  return "/clause/privacy/v1.1";
}

/** 지금 시각 기준으로 고지는 시작됐지만 아직 시행 전인 예정 버전이 있으면 그 경로를, 없으면 null을 반환한다. */
export function getScheduledBiztingPrivacyRoute(now: Date = new Date()): string | null {
  if (now >= PRIVACY_V14_NOTICE_START_AT && now < PRIVACY_V14_EFFECTIVE_AT) return "/clause/privacy/v1.4";
  if (now >= PRIVACY_V13_NOTICE_START_AT && now < PRIVACY_V13_EFFECTIVE_AT) return "/clause/privacy/v1.3";
  return null;
}

/** 지금 시각 기준으로 실제 시행중인 NPass 개인정보처리방침 버전의 경로를 반환한다. */
export function getCurrentNPassPrivacyRoute(now: Date = new Date()): string {
  if (now >= NPASS_V12_EFFECTIVE_AT) return "/clause/sender/privacy/v1.2";
  return "/clause/sender/privacy/v1.1";
}

/** 지금 시각 기준으로 고지는 시작됐지만 아직 시행 전인 NPass 예정 버전이 있으면 그 경로를, 없으면 null을 반환한다. */
export function getScheduledNPassPrivacyRoute(now: Date = new Date()): string | null {
  if (now >= NPASS_V12_NOTICE_START_AT && now < NPASS_V12_EFFECTIVE_AT) return "/clause/sender/privacy/v1.2";
  return null;
}

/** 지금 시각 기준으로 실제 시행중인 비즈팅 이용약관 버전의 경로를 반환한다. */
export function getCurrentBiztingTermsRoute(now: Date = new Date()): string {
  if (now >= TERMS_V12_EFFECTIVE_AT) return "/clause/use/v1.2";
  return "/clause/use/v1.1";
}

/** 지금 시각 기준으로 고지는 시작됐지만 아직 시행 전인 이용약관 예정 버전이 있으면 그 경로를, 없으면 null을 반환한다. */
export function getScheduledBiztingTermsRoute(now: Date = new Date()): string | null {
  if (now >= TERMS_V12_NOTICE_START_AT && now < TERMS_V12_EFFECTIVE_AT) return "/clause/use/v1.2";
  return null;
}
